import { MemberSwishStatus } from 'src/modules/invoice/models/memberSwishStatus';
import { MemberSwishStatusSearchFilter } from 'src/modules/invoice/models/memberSwishStatusSearchFilter';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'MemberSwishStatus';

export const getAllMemberSwishStatus = (filter: MemberSwishStatusSearchFilter) => {
  return AxiosInstance.get<PagedResult<MemberSwishStatus>>(`${controller}`, { params: filter });
};

export const getMemberSwishStatusById = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<MemberSwishStatus>(endpoint);
};

// Återkalla medgivande (Swish consent). Backend gör DELETE mot Swish recurring/consents/{consentId}
// och avslutar prenumerationen (inv_swishStatus).
export const revokeSwishConsent = (swishConsentId: number) => {
  const endpoint = `${controller}/consent/${swishConsentId}`;
  return AxiosInstance.delete(endpoint);
};

// Ta bort Swish Återkommande som betalsätt: raderar ENDAST inv_swishStatus (raden), medgivandet/consenten
// lämnas orört — speglar autogiro där borttagning av betalsätt bara raderar autogiroStatus, inte mandatet.
export const deleteMemberSwishStatus = (swishStatusId: number) => {
  const endpoint = `${controller}/${swishStatusId}`;
  return AxiosInstance.delete(endpoint);
};
